/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { getTableConfiguration } from '../../../../../utils/universalTracker'
import { ValueTable } from '@g17eco/types/universalTracker';
import { TableDataInfo } from '@g17eco/types/questionInterfaces';
import { ColumnMap, convertInputData, createConversionParams } from '@utils/valueDataTable';
import { getConvertedValue, getPopulatedConnectionValue, isSameValue } from '@utils/universalTrackerValue';

interface TableSubmitValues {
  submitValues: any;
  table?: TableDataInfo;
  universalTracker: any;
}

export const updateTableDataSubmitValues = (submitData: TableSubmitValues) => {

  const { submitValues, table, universalTracker } = submitData;

  const tableConfig: ValueTable | undefined = getTableConfiguration(universalTracker);

  if (!tableConfig || !table || !Array.isArray(table.rows)) {
    return submitValues;
  }

  const { columns } = tableConfig;
  const mapCode: ColumnMap = new Map(columns.map(c => [c.code, c]));

  const rowData = table.rows.filter(r => !r.isRemoved).map(r => r.data);

  submitValues.valueData.input.table = rowData.map((rowColumns) => {
    return rowColumns.map((col) => {
      const colMetadata = mapCode.get(col.code);
      if (!colMetadata) {
        return col;
      }
      const params = createConversionParams(colMetadata, col);
      const { isCurrency, defaultUnit, defaultNumberScale } = params;
      const unit = isCurrency ? undefined : col.unit ?? defaultUnit;
      const convertedConnectionValue = getPopulatedConnectionValue(col.source, params);
      const convertedValue = getConvertedValue(params);
      return {
        ...col,
        source: isSameValue(convertedConnectionValue, convertedValue) ? col.source : undefined,
        numberScale: col.numberScale ?? defaultNumberScale,
        unit,
      };
    });
  });

  submitValues.valueData.table = convertInputData(rowData, mapCode);
  return submitValues;
}
